import React from "react";
import { Box } from "@mui/material";
import { useRecordContext } from "react-admin";
import RequestActionBox from "../RequestActionBox";

const LeaveActionButtons = ({ type }) => {
  const record = useRecordContext();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", marginTop: "0.5rem" }}>
      <RequestActionBox
        type={type}
        status={record?.status}
      />
    </Box>
  );
};

export default LeaveActionButtons;
